import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IconButton, CircularProgress, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocViewer from "@cyntler/react-doc-viewer";
import { Download } from "@mui/icons-material";
import { show_proper_words } from "../../utils/Constant";
import { useEffect } from "react";
import { useIds } from "../../hook/AdminContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: 1000,
  height: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  display: "flex",
  flexDirection: "column",
  outline: "none",
};

export default function DocumentModalboxCv({
  open,
  handleClose,
  image_url,
  type,
  previewDoc,
  docName = "",
  handleChangeReadStatus = () => {},
  handleChangeStatusOfCandidate = null,
}) {
  const { GetAccessOfCompany } = useIds();

  const docs = [{ uri: image_url }];

  const fileExtension = image_url.startsWith("blob:")
    ? docName?.split(".").pop().toLowerCase()
    : image_url?.split(".").pop().toLowerCase();

  const fileName = image_url.startsWith("blob:")
    ? docName
    : image_url?.split("/").pop();

  useEffect(() => {
    if (open) {
      if (!previewDoc?.read_status) {
        handleChangeReadStatus(previewDoc, true);
      }
    }
  }, [open]);

  const PDFViewer = ({ fileUrl }) => {
    // React.useEffect(() => {
    //   debugPDF(fileUrl);
    // }, [fileUrl]);

    return (
      <iframe
        className="iframe-content"
        src={fileUrl}
        title="PDF Viewer"
        width="100%"
        height="100%"
        style={{ border: "none", flex: 1 }}
      />
    );
  };

  // 🔍 Debug Function for Simple PDF
  async function debugPDF(fileUrl) {
    // console.clear();
    console.info("%c🔍 Debugging PDF Viewer", "color:#0af;font-size:16px;");
    console.info("PDF URL:", fileUrl);

    // 1️⃣ Check PDF File Accessibility
    console.info(
      "\n%c1️⃣ Checking PDF File Reachability...",
      "color:#09f;font-weight:bold;"
    );
    try {
      const res = await fetch(fileUrl, { method: "HEAD" });

      console.info("➡ Status:", res.status);

      if (!res.ok) {
        console.error(
          "❌ PDF file NOT reachable! Might be S3 permissions or expired link."
        );
      } else {
        console.info("✔ PDF file is reachable");

        console.table({
          "Content-Type": res.headers.get("content-type"),
          "Content-Length": res.headers.get("content-length"),
          "CORS Allow-Origin": res.headers.get("access-control-allow-origin"),
          "Content-Disposition": res.headers.get("content-disposition"),
        });

        // Validate PDF MIME type
        const type = res.headers.get("content-type") || "";
        if (!type.includes("pdf")) {
          console.warn("⚠ Content-Type is NOT PDF! Viewer may fail.");
        }

        // Validate file size
        const size = parseInt(res.headers.get("content-length") || "0", 10);
        if (size < 1000) {
          console.warn("⚠ File size looks too small — PDF may be corrupted.");
        }
      }
    } catch (e) {
      console.error("❌ Error checking PDF file:", e);
    }

    // 2️⃣ Check if iframe can embed PDF (CORS)
    console.info(
      "\n%c2️⃣ Checking iframe embedding permission...",
      "color:#09f;font-weight:bold;"
    );
    try {
      const textRes = await fetch(fileUrl);
      const blob = await textRes.blob();

      if (blob.type !== "application/pdf") {
        console.warn("⚠ Blob type is not PDF:", blob.type);
      } else {
        console.info("✔ PDF blob seems valid");
      }
    } catch (e) {
      console.error("❌ Failed loading PDF blob — likely CORS issue", e);
    }

    console.info(
      "\n%c📌 PDF Debug Completed — check logs above.",
      "color:#ffaa00;font-size:16px;"
    );
  }

  const GoogleDocViewer = ({ fileUrl }) => {
    //   const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
    //   fileUrl
    // )}&embedded=true`;
    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      fileUrl
    )}`;

    // React.useEffect(() => {
    //   debugGoogleViewer(fileUrl, viewerUrl);
    // }, [fileUrl]);

    return (
      <>
        {viewerUrl && (
          <iframe
            className="iframe-content"
            src={viewerUrl}
            title="DOC/DOCX Viewer"
            width="100%"
            height="100%"
            origin="true"
            style={{ border: "none", flex: 1 }}
          />
        )}
      </>
    );
  };

  // 🔍 Debug Function
  async function debugGoogleViewer(rawUrl, viewerUrl) {
    // console.clear();
    console.info(
      "%c🔍 Google Docs Viewer Debugging",
      "color:#00aaff;font-size:14px;"
    );
    console.info("\nRAW File:", rawUrl);
    console.info("Google Viewer URL:", viewerUrl);

    // 1️⃣ Check RAW S3 File
    console.info(
      "\n%c1️⃣ Checking RAW S3 file URL...",
      "color:#0af;font-weight:bold;"
    );
    try {
      const raw = await fetch(rawUrl, { method: "HEAD" });

      console.info("➡ Status:", raw.status);
      if (!raw.ok) {
        console.error("❌ Cannot access RAW file. S3 issue.");
      } else {
        console.info("✔ RAW File Accessible");
        console.table({
          "Content-Type": raw.headers.get("content-type"),
          "Content-Length": raw.headers.get("content-length"),
          "Content-Disposition": raw.headers.get("content-disposition"),
          "CORS Allow-Origin": raw.headers.get("access-control-allow-origin"),
        });
      }
    } catch (e) {
      console.error("❌ RAW File Fetch Error:", e);
    }

    // 2️⃣ Check Google Doc Viewer
    console.info(
      "\n%c2️⃣ Checking Google Docs Viewer...",
      "color:#0af;font-weight:bold;"
    );
    try {
      const viewerRes = await fetch(viewerUrl);

      console.info("➡ Status:", viewerRes.status);
      if (!viewerRes.ok) {
        console.error("❌ Google Docs Viewer returned an error.");
        return;
      }

      const text = await viewerRes.text();
      if (text.includes("Sorry, we are unable to display")) {
        console.error("❌ Google Docs Viewer CANNOT display this file!");
      } else {
        console.info("✔ Google Docs Viewer responded normally.");
      }
    } catch (e) {
      console.error("❌ Google Docs Viewer Fetch Error:", e);
    }

    console.info(
      "\n%c📌 Debug Complete — Check logs above.",
      "color:#ffaa00;font-size:14px;"
    );
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
    >
      <Box sx={style} mb={4}>
        {/* Header with Download and Close */}
        <div className="row py-3 px-4">
          {/* Candidate Name */}
          <div className="col-12 col-lg-6">
            {" "}
            <h4
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
              className="line-clamp-1 w-100"
            >
              {(() => {
                return fileName;
              })()}
            </h4>
          </div>
          <div className="col-12 col-lg-6 text-end">
            {" "}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {handleChangeStatusOfCandidate &&
                (GetAccessOfCompany("job?.add") ||
                  GetAccessOfCompany("job?.update")) && (
                  <>
                    {previewDoc?.application_response !== "rejected" && (
                      <button
                        className="btn-outlined-sm !tw-py-1 tw-me-2"
                        disabled={
                          previewDoc?.rejected_loading ||
                          previewDoc?.accepted_loading
                        }
                        onClick={() => {
                          handleChangeStatusOfCandidate(previewDoc, "rejected");
                        }}
                      >
                        {previewDoc?.rejected_loading
                          ? "Rejecting..."
                          : "Reject"}
                      </button>
                    )}
                    {previewDoc?.application_response !== "accepted" && (
                      <button
                        className="btn-outlined-sm !tw-py-1 tw-me-2"
                        disabled={
                          previewDoc?.rejected_loading ||
                          previewDoc?.accepted_loading
                        }
                        onClick={() => {
                          handleChangeStatusOfCandidate(previewDoc, "accepted");
                        }}
                      >
                        {previewDoc?.accepted_loading
                          ? "Accepting..."
                          : "Accept"}
                      </button>
                    )}
                  </>
                )}
              {image_url && (
                <button
                  onClick={async () => {
                    console.log("onCLick");
                    try {
                      const response = await fetch(image_url);
                      if (!response.ok)
                        throw new Error("Network response was not ok");
                      const blob = await response.blob();
                      const url = window.URL.createObjectURL(blob);
                      // Build file name from previewDoc
                      let firstName = previewDoc?.first_name
                        ? previewDoc.first_name.trim().replace(/\s+/g, "_")
                        : "";
                      let lastName = previewDoc?.last_name
                        ? previewDoc.last_name.trim().replace(/\s+/g, "_")
                        : "";
                      if (
                        ["N/A", "NA", "n/a", "na"].includes(
                          lastName.toUpperCase()
                        )
                      ) {
                        lastName = "";
                      }
                      let fullName =
                        (firstName + (lastName ? "_" + lastName : "")).replace(
                          /_+/g,
                          "_"
                        ) ||
                        previewDoc?.name ||
                        "cv";
                      let ext = fileExtension;
                      let cvName = fileName;
                      const customName = `CV_${fullName}.${ext}`;
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = cvName || customName;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);
                    } catch (err) {
                      alert("Failed to download CV.");
                    }
                  }}
                  className="btn-contained-sm !tw-py-1 tw-me-2"
                >
                  Download
                  <Download fontSize="14px" style={{ color: "white" }} />
                </button>
              )}
              <IconButton
                onClick={handleClose}
                sx={{
                  backgroundColor: "navy",
                  fontSize: "10px",
                  padding: "3px !important",
                  "&:hover": { backgroundColor: "navy" },
                  ml: 1,
                }}
                aria-label="close"
              >
                <CloseIcon style={{ color: "white" }} fontSize="small" />
              </IconButton>
            </Box>
          </div>
        </div>

        {/* Image Preview */}

        {/* PDF or Other Document Viewer */}
        {fileExtension === "pdf" ? (
          // <iframe
          //   className="iframe-content"
          //   src={image_url}
          //   title="PDF Viewer"
          //   width="100%"
          //   height="100%"
          //   style={{ border: "none", flex: 1 }}
          // />
          <PDFViewer fileUrl={image_url} />
        ) : fileExtension === "doc" || fileExtension === "docx" ? (
          // <iframe
          //   className="iframe-content"
          //   src={`https://docs.google.com/gview?url=${encodeURIComponent(
          //     image_url
          //   )}&embedded=true`}
          //   title="DOC/DOCX Viewer"
          //   width="100%"
          //   height="100%"
          //   style={{ border: "none", flex: 1 }}
          // />
          <>
            <GoogleDocViewer fileUrl={image_url} />
          </>
        ) : (
          <Box sx={{ width: "100%", height: "100%", overflow: "auto" }}>
            <DocViewer
              documents={docs}
              config={{
                header: { disableHeader: true },
              }}
              style={{
                width: "100%",
                minWidth: "fit-content",
                height: "100%",
                flex: 1,
              }}
            />
          </Box>
        )}

        {/* Download Button */}
      </Box>
    </Modal>
  );
}
